import type { MailboxInfo } from 'owa-client-types';
import { action } from 'satcheljs';

export interface OpenSharedMailboxSettingsActionMessage {
    mailboxInfo: MailboxInfo;
}

export const openSharedMailboxSettings: (
    mailboxInfo: MailboxInfo
) => OpenSharedMailboxSettingsActionMessage = action(
    'openSharedMailboxSettings',
    (mailboxInfo: MailboxInfo): OpenSharedMailboxSettingsActionMessage => ({
        mailboxInfo,
    })
);
